const doc = [({"da":({"js":({"admin":({"orders":({"generate_packing_slips_for_orders_in_workplace_button":({"generate_packing_slips_for_orders":"Generer pakkeseddler for ordrer"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;